import { Routes, Route, Navigate } from 'react-router-dom'
import { BrowserView, MobileView } from 'react-device-detect'

import RequestListDesktopView from 'Presentation/Views/Request/List/DesktopView'
import RequestListMobileView from 'Presentation/Views/Request/List/MobileView'
import IssueRequestSteelPlates from 'Presentation/Views/Request/Form/RequestSteelPlates/View'
import IssueRequestChangePileSize from 'Presentation/Views/Request/Form/RequestChangePileSize/View'
import IssueRequestChangeShipping from 'Presentation/Views/Request/Form/RequestChangeShipping/View'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const RequestRoutes = () => (
  <Routes>
    <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.request} />}>
      <Route
        index
        element={
          <>
            <BrowserView>
              <RequestListDesktopView />
            </BrowserView>

            <MobileView>
              <RequestListMobileView />
            </MobileView>
          </>
        }
      />

      <Route path='/steel-plates/create' element={<IssueRequestSteelPlates />} />
      <Route path='/steel-plates/:id' element={<IssueRequestSteelPlates />} />

      <Route path='/change-pile-size/create' element={<IssueRequestChangePileSize />} />
      <Route path='/change-pile-size/:id' element={<IssueRequestChangePileSize />} />

      <Route path='/change-shipping/create' element={<IssueRequestChangeShipping />} />
      <Route path='/change-shipping/:id' element={<IssueRequestChangeShipping />} />

      <Route path='*' element={<Navigate to='/home' />} />
    </Route>
  </Routes>
)

export default RequestRoutes
